import { useCallback } from 'react';
import useSWR, { MutatorOptions, useSWRConfig } from 'swr';
import { getQueriesForClient } from '~/app/_repositories/query-service';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';

const getKey = (userId: string) => ['use-follow-status', userId];

const fetcher = async (key: string, userId: string) => {
  const result = await getQueriesForClient({
    request_list: [
      {
        request_id: key,
        user_request: {
          id: userId,
          require_user: {
            require_is_followed_by_me: true,
            require_is_following_me: true,
          },
        },
      },
    ],
  });
  const isFollowedByMe =
    result?.response_list[0]?.user?.is_followed_by_me || false;
  const isFollowingMe =
    result?.response_list[0]?.user?.is_following_me || false;

  return {
    isFollowedByMe,
    isFollowingMe,
  };
};

export const useFetchUserFollowStatus = (userId: string | undefined) => {
  const { session } = useTellerSession();
  const { data, error } = useSWR(
    session && userId ? getKey(userId) : undefined,
    ([key, userId]: [string, string]) => fetcher(key, userId)
  );

  return {
    value: data,
    loading: !data,
    error,
  };
};

export const useRevalidateUserFollowStatus = () => {
  const { mutate } = useSWRConfig();

  const revalidateUserFollowStatus = useCallback(
    (
      userId: string,
      data?: boolean | Promise<boolean>,
      options?: MutatorOptions
    ) => mutate(getKey(userId), data, options),
    [mutate]
  );

  return {
    revalidateUserFollowStatus,
  };
};
